export default __webpack_public_path__ + "static/media/(3).9d2b360a.jpg";